import { AddNoteModal } from 'components/shared/Modals'
import { useLazyRecentActivityDetailQuery } from 'features/leads/api'
import { useLeadDetails } from 'features/leads/providers/LeadDetailsProvider'
import {
 TMainActivityTypes,
 TUserActivityNote,
 TUserAllActivity,
} from 'features/leads/types'
import useFetchPageNew from 'hooks/useFetchpageNew'
import useAuth from 'hooks/useAuth'
import { FC, useState } from 'react'
import { TModalState } from 'types'
import ActivityLayout from './components/ActivityLayout'
import { AllActivityEmptyState } from './components/LeadTimelineEmptyStates'

export type TRecentAcitivityReq = {
 type?: TMainActivityTypes
 activity_id?: number
 lead_id?: number
}

const AllActivity: FC = () => {
 const { leadId, realtorId } = useLeadDetails()
 const { user } = useAuth()
 const [noteModal, setNoteModal] = useState<TModalState<TUserActivityNote>>({
  show: false,
  mode: 'ADD',
 })

 const {
  flatData,
  isLoading,
  fetchMore,
  hasMore,
  isRefetching,
  refetch,
  total,
 } = useFetchPageNew<TUserAllActivity>(`lead/profile/${leadId}`, {
  body: { type: 'all', ...(realtorId ? { realtor_id: realtorId } : {}) },
  method: 'post',
 })

 const [
  recentActivityDetail,
  { data: detailData, isLoading: detailLoading, isFetching: detailFetching },
 ] = useLazyRecentActivityDetailQuery()

 const fetchDetail = async (val: TRecentAcitivityReq & { index?: number }) => {
  //   delete val?.index
  const { index, lead_id, ...values } = val
  await recentActivityDetail({
   ...values,
   lead_id: leadId,
   ...(realtorId ? { realtor_id: realtorId } : {}),
  }).unwrap()
 }

 return (
  <>
   <ActivityLayout
    refetechList={refetch}
    totalCount={total}
    totalTitle="ALL"
    emptyState={
     <AllActivityEmptyState
      onAddNote={() => setNoteModal({ show: true, mode: 'ADD' })}
     />
    }
    detailLoading={detailFetching || detailLoading}
    fetchDetail={fetchDetail}
    listFetchMore={fetchMore}
    listHasMore={hasMore}
    listisRefetching={isRefetching}
    flatData={flatData}
    listIsLoading={isLoading}
    detailData={detailData}
    onEditNote={(item) =>
     setNoteModal({
      show: true,
      mode: 'EDIT',
      data: {
       ...item,
       content: item?.content ?? item?.description,
      },
     })
    }
    setItemCard={(val: any) => {
     // The merged "all" feed returns a generic title ("Note Added") with no
     // creator baked in — resolve the creator here so the card can show it
     // as an avatar chip next to the timestamp.
     const isOwnNote =
      val?.create_by_user_id != null &&
      String(val.create_by_user_id) === String(user?.id)
     const creatorName =
      val?.create_by_user_name ?? (isOwnNote ? user?.name : undefined)
     const isNote = val?.type === 'note'
     return {
      title: val?.title,
      description: val?.description,
      updated: val?.updated,
      createdBy: isNote ? creatorName : undefined,
     }
    }}
   />
   {noteModal.show && (
    <AddNoteModal
     visible={noteModal.show}
     mode={noteModal.mode}
     editData={noteModal.data}
     leadId={leadId}
     onCancel={() => setNoteModal({ show: false, mode: 'ADD' })}
     onSuccess={() => {
      refetch()
      setNoteModal({ show: false, mode: 'ADD' })
     }}
    />
   )}
  </>
 )
}

export default AllActivity
